module.exports = __webpack_public_path__ + "static/img/imgUSAw-listings@2x.b58f3de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgUSAw-listings@2x.png
// module id = qaVZ
// module chunks = 0